import { render } from "./ShipContentSearch.vue?vue&type=template&id=d80f2f7e"
import script from "./ShipContentSearch.vue?vue&type=script&lang=js"
export * from "./ShipContentSearch.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__